import * as React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLoaderData } from 'react-router-dom';

import { RoleFormContext } from 'context';
import type { ComponentMode, Role as RoleConfig } from 'types';

import { RoleForm, RoleHeader } from './components';

type RoleProps = {
  mode: ComponentMode;
};

export default function Role({ mode }: RoleProps) {
  const data = useLoaderData() as RoleConfig | undefined;

  const { name } = data ?? {};
  const isUpdatedMode = mode === 'Update';

  const title = isUpdatedMode ? `دسترسی ${name}` : 'افزودن دسترسی جدید';
  const defaultName = isUpdatedMode ? name : '';

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${title} | کاشی لند`}</title>
      </Helmet>
      <RoleHeader>{title}</RoleHeader>
      <RoleFormContext
        mode={mode}
        defaultName={defaultName}
        {...(isUpdatedMode ? data : {})}
      >
        <RoleForm />
      </RoleFormContext>
    </React.Fragment>
  );
}
